module.exports = __webpack_public_path__ + "assets/images/template/project/photo-4.jpg?v=adc317b2";